import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import ChatWidget from "../components/ChatWidget";
import { ArrowLeft, Clock, ChefHat, PackageCheck, CheckCircle2, XCircle } from "lucide-react";

const STATUS = {
  pending: { label: "Alındı", cls: "text-amber-400 bg-amber-950/40 border-amber-500/30", icon: Clock },
  preparing: { label: "Hazırlanıyor", cls: "text-blue-400 bg-blue-950/40 border-blue-500/30", icon: ChefHat },
  ready: { label: "Hazır", cls: "text-emerald-400 bg-emerald-950/40 border-emerald-500/30", icon: PackageCheck },
  completed: { label: "Tamamlandı", cls: "text-emerald-400 bg-emerald-950/40 border-emerald-500/30", icon: CheckCircle2 },
  cancelled: { label: "İptal", cls: "text-rose-400 bg-rose-950/40 border-rose-500/30", icon: XCircle },
};

export default function MyOrders() {
  const { user } = useAuth();
  const [orders, setOrders] = useState([]);

  const load = () => api.get("/orders/mine").then((r) => setOrders(r.data)).catch(() => {});
  useEffect(() => { load(); const t = setInterval(load, 5000); return () => clearInterval(t); }, []);

  return (
    <div className="min-h-screen bg-[#0B0B0C]">
      <div className="glass sticky top-0 z-30">
        <div className="max-w-3xl mx-auto px-5 py-3 flex items-center justify-between">
          <Link to="/menu" className="flex items-center gap-2 text-zinc-300 hover:text-[#FFE599]" data-testid="myorders-back"><ArrowLeft size={18} /> Menüye Dön</Link>
          <span className="font-serif text-xl gold-text">Siparişlerim</span>
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-5 py-8">
        {user?.status !== "approved" && (
          <div className="rounded-xl bg-amber-950/40 border border-amber-500/30 px-4 py-3 text-amber-200 text-sm text-center mb-6">
            Hesabınız onay bekliyor. Onaylandıktan sonra sipariş verebilirsiniz.
          </div>
        )}
        {orders.length === 0 && <p className="text-center text-zinc-500 py-16">Henüz siparişiniz yok. <Link to="/menu" className="text-[#FFE599]">Menüye göz atın</Link></p>}
        <div className="space-y-4">
          {orders.map((o) => {
            const st = STATUS[o.status] || STATUS.pending;
            const Icon = st.icon;
            return (
              <div key={o.id} className="card-lux p-5" data-testid={`myorder-${o.id}`}>
                <div className="flex items-center justify-between mb-3">
                  <span className="font-mono text-xs text-zinc-400">#{o.id.slice(0, 8)} • {o.type === "table" ? `Masa ${o.tableNo}` : "Paket"}</span>
                  <span className={`flex items-center gap-1.5 text-xs px-3 py-1 rounded-full border ${st.cls}`}><Icon size={13} />{st.label}</span>
                </div>
                <div className="space-y-1">
                  {o.items.map((it, i) => <div key={i} className="flex justify-between text-sm text-zinc-300"><span>{it.qty}x {it.name}</span><span className="font-mono">₺{(it.price * it.qty).toFixed(2)}</span></div>)}
                </div>
                <div className="mt-3 pt-3 border-t border-[#D4AF37]/15 flex justify-between text-sm"><span className="text-zinc-400">Toplam</span><span className="font-mono text-[#FFE599]">₺{o.total.toFixed(2)}</span></div>
              </div>
            );
          })}
        </div>
      </div>
      <ChatWidget />
    </div>
  );
}
